import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=18c4f0c6&scoped=true"
import script from "./ImageThumbnail.vue?vue&type=script&lang=js"
export * from "./ImageThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ImageThumbnail.vue?vue&type=style&index=0&id=18c4f0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4f0c6",
  null
  
)

export default component.exports